import { useEffect } from 'react';
import CargoOwner from './cargo-owner';
import FieldOwner from './field-owner';
import useFieldCargoOwner from '@/hooks/useFieldCargoOwner';
import { showUserVoice } from '@/components/userVoice';

function NewOperatePlatform() {
  useEffect(() => {
    showUserVoice?.('730');
  }, []);

  return useFieldCargoOwner(<FieldOwner />, <CargoOwner />);
}

export default NewOperatePlatform;
